/* Package JSON Import will be here */
import React from "react";
import { useSelector } from "react-redux";
import { Card, Row, Col, Badge, Divider, Typography, Alert, Tabs } from "antd";
import { orderBy, isEmpty } from "lodash";
import { getTranslate } from "react-localize-redux";
import Img from "react-image";
/* Package JSON Import will be here */

/* Project Import will be here */
import { currencySymbol, getCultureNumberFormat, checkFileTypeIsVideo, checkFileTypeIsImage } from "utilities/utils";
import Constant from "../../utilities/appConstants";
import Constants from "utilities/appConstants";
import VideoPlayer from "components/reusable/VideoPlayer";
import { BannerPlaceholder } from "components/Spinner";
import bannerPlaceholderImg from "assets/img/banner-placeholder.png";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Meta } = Card;
const { Text } = Typography;
const { TabPane } = Tabs;
/* Const,Let & Var will be here */

const PromoDetails = (props) => {
  const { promotions, appSettings, translate } = useSelector((state) => ({
    promotions: props.pageType === Constants.PRODUCT_DETAILS
      ? state.promotions.details
      : state.promotions.list,
    appSettings: state.appSettings,
    translate: getTranslate(state.locale)
  }));

  /* Get the get group name based on the value percentage and forEvery */
  const fetchGetGroupName = (slab, schemeInfo) => {
    if (slab.DiscountEveryQty > 0)
      return (schemeInfo.Type.toUpperCase() === Constant.QTY ? `${translate("products.productLabel.forEvery")} ${slab.DiscountEveryQty} ${translate("products.productLabel.unit")}` : `${translate("products.productLabel.forEvery")} ${getCultureNumberFormat(slab.DiscountEveryQty, true)}`);
    else
      return (slab.Amount === 0 ? `% ${translate("products.productLabel.discount")}` : `${currencySymbol} ${translate("products.productLabel.discount")}`);
  }

  const slabGetContent = (slab, schemeInfo) => {
    if (slab.GetGroupList && slab.GetGroupList.length > 0) {
      return (
        slab.GetGroupList.map((group, groupIndex) => {
          return (
            <React.Fragment key={group.GroupId}>
              <div className="bg-small-gray m-1 p-1">
                {group.ProductList.map((product, productIndex) => {
                  return (
                    <React.Fragment key={product.PId}>
                      <Row className="p-1">
                        <Col span={12} className="text-left">
                          {product.PName}
                        </Col>
                        <Col span={12} className="text-center">
                          {`${product.Min} ${translate("products.productLabel.unit")} - ${product.Max} ${translate("products.productLabel.unit")}`}
                        </Col>
                      </Row>
                      {group.ProductList.length !== parseInt(productIndex, 10) + 1 && <div className="p-1 text-center">{group.GroupLogic}</div>}
                    </React.Fragment>
                  );
                })}
              </div>

              {slab.GetGroupList.length !== parseInt(groupIndex, 10) + 1 && <div className="p-1 text-center">{schemeInfo.SchemeGetLogic}</div>}
            </React.Fragment>
          );
        })
      )
    }
    else {
      return (
        <Row className="mt-2 pl-2">
          <Col span={12}>
            {fetchGetGroupName(slab, schemeInfo)}
          </Col>
          <Col span={12} className="text-center">
            {slab.Amount === 0 ? `${slab.Per}%` : `${getCultureNumberFormat(slab.Amount, true)}`}
          </Col>
        </Row>
      )
    }
  };

  const slabBuyContent = (slab, schemeInfo) => {
    return (
      slab.BuyGroupList.map((group, groupIndex) => {
        return (
          <React.Fragment key={group.GroupId}>
            <div className="bg-small-gray m-1 p-1">
              {group.ProductList.map((product, productIndex) => {

                /* check the scheme type qty, weight or per  */
                const checkSchemeType = () => {
                  if (schemeInfo.Type.toUpperCase() === Constant.QTY)
                    return `${product.Min} ${translate("products.productLabel.unit")} - ${product.Max} ${translate("products.productLabel.unit")}`
                  else if (schemeInfo.Type.toUpperCase() === Constant.WEIGHT)
                    return `${product.Min} ${translate("products.productLabel.gm")} - ${product.Max} ${translate("products.productLabel.gm")}`
                  else
                    return `${getCultureNumberFormat(product.Min, true)} - ${getCultureNumberFormat(product.Max, true)}`
                };

                return (
                  <React.Fragment key={product.PId}>
                    <Row className="p-1">
                      <Col span={12} className="text-left">
                        {product.PName}
                      </Col>
                      <Col span={12} className="text-center pl-2">
                        {checkSchemeType()}
                      </Col>
                    </Row>
                    {group.ProductList.length !== parseInt(productIndex, 10) + 1 && <div className="p-1 text-center">{group.GroupLogic}</div>}
                  </React.Fragment>
                );
              })}
            </div>

            {slab.BuyGroupList.length !== parseInt(groupIndex, 10) + 1 && <div className="p-1 text-center">{schemeInfo.SchemeBuyLogic}</div>}
          </React.Fragment>
        );
      })
    )
  };

  const SchemeSlabGroups = (slabs, schemeInfo) => {
    return (
      <Tabs defaultActiveKey="1" centered className="scheme-details-tab">
        {slabs.map((slab, index) => {
          return (
            <TabPane tab={translate("promotion.slab") + " " + (parseInt(index, 10) + 1).toString()} key={(parseInt(index, 10) + 1).toString()}>
              {/* Slab Name Details */}
              <div className="p-3"><span>{translate("promotion.slabNameDesc")}</span> - <span className="color-primary font-bold">{slab.Narration}</span></div>

              {/* Buy group render */}
              <Row className="m-1">
                <Col span={12}>
                  <Alert
                    className="pl-2 border-radius-left-15"
                    type="success"
                    message={<Text strong type="success">{translate("promotion.buyProductName")}</Text>}
                  />
                </Col>
                <Col span={12} className="text-center">
                  <Alert
                    className="pl-2 pl-2 border-radius-right-15"
                    type="success"
                    message={<Text strong type="success">{translate(schemeInfo.Type.toUpperCase() === Constant.QTY ? "promotion.buyQuantity" : "promotion.buyValue")}</Text>}
                  />
                </Col>
              </Row>
              {slabBuyContent(slab, schemeInfo)}

              <Divider />

              {/* Get group render */}
              <Row className="m-1">
                <Col span={12}>
                  <Alert
                    className="pl-2 border-radius-left-15"
                    type="success"
                    message={<Text strong type="success">{(slab.GetGroupList && slab.GetGroupList.length > 0) ? translate("promotion.getProductName") : translate("promotion.get")}</Text>}
                  />
                </Col>
                <Col span={12} className="text-center">
                  <Alert
                    className="pl-2 pl-2 border-radius-right-15"
                    type="success"
                    message={<Text strong type="success">{translate("promotion.benefit")}</Text>}
                  />
                </Col>
              </Row>
              {slabGetContent(slab, schemeInfo)}
            </TabPane>
          )
        })}
      </Tabs>
    )
  }

  const schemeDetailsCard = () => {
    const selectedPromo = promotions.selectedPromotionDetails;
    const slabs = !(isEmpty(selectedPromo)) ? orderBy(selectedPromo.Slab, ['Id'], ['asc']) : "";
    const schemeInfo = !(isEmpty(selectedPromo)) ? selectedPromo.Scheme : "";

    return (
      <Card className="promotion-card-shadow border-radius-15">
        {/* Title, start and end date */}
        <Meta
          className="scheme-details-popup"
          title={schemeInfo.Desc}
          description={
            <Row gutter={[8, 8]} className="responsive-font-size">
              {(appSettings.isShowNarrationInSchemeDetailsPage && (schemeInfo.Desc !== schemeInfo.Narration)) &&
                <Col span={24} className="per-line">
                  {schemeInfo.Narration}
                </Col>
              }
              <Col span={12}>
                <Badge status="success" />
                {translate("promotion.start")}: {schemeInfo.StartDate}
              </Col>
              <Col span={12}>
                <Badge status="error" />
                {translate("promotion.end")}: {schemeInfo.EndDate}
              </Col>
            </Row>
          }
        />

        <Divider />

        {/* Scheme and Slab details */}
        {SchemeSlabGroups(slabs, schemeInfo)}
      </Card>
    );
  }

  const getSchemeMediaTab = () => {
    const selectedSchemeBanner = promotions.selectedPromotionDetails.Banners[0];

    return (
      <React.Fragment>
        {(checkFileTypeIsVideo(selectedSchemeBanner) && selectedSchemeBanner.Url !== "") &&
          <VideoPlayer
            videoUrl={selectedSchemeBanner.Url}
            light={false}
          />
        }

        {(checkFileTypeIsImage(selectedSchemeBanner) || selectedSchemeBanner.Url === "") &&
          <Img
            className="border-radius-15 object-fit-contain banner-details-image-height bg-white"
            alt="" src={[selectedSchemeBanner.Url, bannerPlaceholderImg]}
            loader={<BannerPlaceholder />}
          />
        }

        {/* Banner description block */}
        {(selectedSchemeBanner.FullDesc !== null && selectedSchemeBanner.FullDesc !== "") &&
          <div className="p-1">
            <div className="responsive-font-size">{translate("home.banner.bannerDesc")}</div>
            <div className="p-2 ql-editor" dangerouslySetInnerHTML={{ __html: selectedSchemeBanner.FullDesc }} />
          </div>
        }
      </React.Fragment>
    )
  }

  const getTabPaneSequence = () => {
    if (props.promoDetailsPageType === Constants.HOME_PAGE_SECTIONS_BANNER) {
      return (
        <React.Fragment>
          <TabPane className="mt-1" tab={translate("promotion.schemeBannerDetails")} key="1">
            {getSchemeMediaTab()}
          </TabPane>
          <TabPane className="mt-1" tab={translate("promotion.schemeDetails")} key="2">
            {schemeDetailsCard()}
          </TabPane>
        </React.Fragment>
      );
    }
    else {
      return (
        <React.Fragment>
          <TabPane className="mt-1" tab={translate("promotion.schemeDetails")} key="1">
            {schemeDetailsCard()}
          </TabPane>
          <TabPane className="mt-1" tab={translate("promotion.schemeBannerDetails")} key="2">
            {getSchemeMediaTab()}
          </TabPane >
        </React.Fragment>
      );
    }
  }

  const renderComp = () => {
    const selectedPromo = promotions.selectedPromotionDetails;

    if (selectedPromo.Banners.length > 0) {
      return (
        <Tabs centered className="tab-bg-color product-details-tabs responsive-font-size" defaultActiveKey="1">
          {getTabPaneSequence()}
        </Tabs>
      );
    }
    else {
      return (schemeDetailsCard());
    }
  }

  return (renderComp());
}

export default PromoDetails;